export default __webpack_public_path__ + "static/inline-edit-do-4a6a453aecd30ac80cfa26b9f38212d4.png";